// Interceptor global de fetch - adiciona Authorization header automaticamente
// para todas as requisições ao backend API.

const originalFetch = window.fetch;

const _CONFIGURED_API_URL = process.env.REACT_APP_API_URL || '';

// Extrai o hostname da URL de API configurada para detectar chamadas ao backend remoto
let _configuredApiHost = '';
try {
    if (_CONFIGURED_API_URL) {
        _configuredApiHost = new URL(_CONFIGURED_API_URL).hostname;
    }
} catch (_) { /* ignora URL inválida */ }

window.fetch = function (url, options = {}) {
    const urlStr = typeof url === 'string' ? url : (url instanceof Request ? url.url : String(url));

    // Detecta requisições ao nosso backend (relativas a /api ou ao host configurado)
    const isApiRequest =
        urlStr.startsWith('/api/') ||
        (_configuredApiHost && urlStr.includes(_configuredApiHost));

    if (isApiRequest) {
        // Clonar options para não mutar o objeto original
        options = { ...options };

        // ── Authorization (JWT) ────────────────────────────────────────
        const token = localStorage.getItem('authToken');
        if (token) {
            if (options.headers instanceof Headers) {
                if (!options.headers.has('Authorization')) {
                    options.headers.set('Authorization', `Bearer ${token}`);
                }
            } else {
                options.headers = {
                    ...options.headers,
                    Authorization: options.headers?.Authorization || `Bearer ${token}`
                };
            }
        }
    }

    return originalFetch.call(window, url, options);
};
